import React from "react";
import MUIButton from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

export enum ButtonType { default, cancel, normal, danger, warning };

export interface IButtonProps {
  label: string;
  leftIcon?: React.ReactNode | null;
  rightIcon?: React.ReactNode | null;
  type?: ButtonType;
  loading?: boolean;
  disabled?: boolean;
  hint?: string;
  onClick?: React.MouseEventHandler;
};

export interface IButton extends React.Component {
  renderLeftElement(): React.ReactNode | null;
  renderRightElement(): React.ReactNode | null;
}

class Button extends React.Component<IButtonProps> implements IButton {

  static defaultProps: IButtonProps = {
    label: "Button",
    disabled: false,
    loading: false,
    hint: "",
    type: ButtonType.normal,
    leftIcon: null,
    rightIcon: null,
  }

  renderLeftElement(): React.ReactNode {
    return this.props.leftIcon;
  }

  renderRightElement(): React.ReactNode {
    return this.props.rightIcon;
  }

  render() {
    return (
      <Tooltip title={this.props.hint} arrow>
        <MUIButton
          variant={(this.props.type === ButtonType.normal) || (this.props.type === ButtonType.cancel) ? 'outlined' : 'contained'}
          color={
            this.props.type === ButtonType.normal ? 'primary' :
              (this.props.type === ButtonType.default ? 'primary' :
                (this.props.type === ButtonType.danger ? 'error' :
                  (this.props.type === ButtonType.warning ? 'warning' :
                    this.props.type === ButtonType.cancel ? 'error' : 'secondary')))
          }
          onClick={this.props.onClick}
          startIcon={this.renderLeftElement()}
          endIcon={this.renderRightElement()}
          size='medium'
          disabled={this.props.disabled || this.props.loading}
        >
          {this.props.label}
        </MUIButton>
      </Tooltip>
    );
  }
}

export default Button;
